import { useOrganizationsStore } from '@/store/organizations';
import { useFiscalCatalogsStore } from '@/store/fiscalCatalogs';
import { useClientTypeStore } from '@/store/clientTypes';

export const productsOptions = {
    searchOrganizations: async (query: string | Record<string, any> = '') => {
        const store = useOrganizationsStore();
        await store.fetchOrganizations(query);
        return store.organizations;
    },
    searchProductUnits: async (query: string | Record<string, any> = '') => {
        const store = useFiscalCatalogsStore();
        await store.searchProductUnits(query);
        return store.product_units;
    },
    searchTaxes: async (query: string | Record<string, any> = '') => {
        const store = useFiscalCatalogsStore();
        await store.searchTaxes(query);
        return store.taxes;
    },
    getClientTypes: async (query: string | Record<string, any> = '') => {
        const store = useClientTypeStore();
        await store.fetchClientTypes(query);
        return store.client_types;
    },
};
